<template>
  <el-dialog
    v-model="modalIsVisible"
    v-loading="loading"
    title="Please choose your option"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :class="{ mobile: !isDesktop }"
  >
    <el-form>
      <el-form-item>
        <el-radio-group v-if="isDesktop" v-model="value">
          <el-radio-button :value="false">
            Create new campaign
          </el-radio-button>
          <el-radio-button :value="true">
            Add to the current campaign whitelist
          </el-radio-button>
        </el-radio-group>
        <el-select v-else v-model="value" placeholder="Choose your option">
          <el-option
            label="Add to the current campaign whitelist"
            :value="true"
          >
            Add to the current campaign whitelist
          </el-option>
          <el-option label="Create new campaign" :value="false">
            Create new campaign
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="value"
        label="Here is a list of your Whitelist campaigns"
      >
        <CampaignSelect v-model="campaignId" :items="campaigns" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="close">Cancel</el-button>
        <el-button type="primary" :disabled="loading" @click="submit">
          Confirm
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import { IMessage } from '@/api/types'
import { useSpotsStore } from '@/apps/traforama/store/spots'
import { useMarketplaceStore } from '@/apps/traforama/store/marketplace'

import CampaignSelect from '@/components/Select/CampaignSelect.vue'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'CampaignWindow',
  components: {
    CampaignSelect
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    }
  },
  setup(props, context) {
    const marketplaceStore = useMarketplaceStore()

    const loading = computed(
      () =>
        Object.keys(marketplaceStore.itemsLoading).length > 0 ||
        marketplaceStore.listLoading
    )
    const spotsStore = useSpotsStore()
    const close = () => {
      context.emit('update:modelValue', false)
      context.emit('close')
    }
    const submit = () => {
      context.emit('update', {
        id: props.id,
        campaignId: value.value ? campaignId.value : null
      })
    }
    const modalIsVisible = computed({
      get: () => {
        return props.visible
      },
      set: (val) => {
        context.emit('update:modelValue', val)
      }
    })
    const { isDesktop } = useResize()

    const campaignId = ref('')
    const value = ref(false)

    const campaigns = computed(() => {
      return (spotsStore.suitableCampaigns || {})[props.id] || []
    })

    return {
      submit,
      close,
      campaignId,
      campaigns,
      value,
      isDesktop,
      loading,
      modalIsVisible
    }
  }
})
</script>

<style lang="scss" scoped>
:deep(.el-dialog__body) {
  text-align: center;
}

:deep(.el-select) {
  width: 80%;
}

:deep(.el-dialog) {
  width: 50%;
}

.mobile {
  :deep(.el-dialog) {
    width: 80%;
  }
}
</style>
